import { Select, Button, Tooltip } from "antd";
import { SortAscendingOutlined, SortDescendingOutlined, MinusOutlined } from "@ant-design/icons";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import { t } from "i18next";

// Özel Başlık Bileşeni
export const StatusSortableHeader = () => {
    const { queryModel, onFilterPageSort } = useDataGrid();

    // 1. Mevcut sıralama durumunu analiz et
    const currentSortItem = queryModel.orderByItems?.[0];

    const sortOptions = [
        { label: t('Confirm Date'), value: 'appointmentEntitlement.confirmStatusDate' },
        { label: t('Complete Date'), value: 'appointmentEntitlement.completeddate' }
    ];

    // Dropdown'da seçili olan değer (Eğer sıralama varsa oradan al, yoksa varsayılan ilki)
    const isActive = sortOptions.some(opt => opt.value === currentSortItem?.name);
    const selectedField = isActive ? currentSortItem?.name : sortOptions[0].value;

    // Mevcut Yön: 0 (Asc), 1 (Desc), veya null (None)
    // Eğer aktif değilse (başka kolon sıralıysa veya hiç yoksa) null kabul et.
    const currentDirection = isActive ? currentSortItem?.operation : null;

    // 2. Sıralama Değiştirme Fonksiyonu (Döngüsel: None -> Asc -> Desc -> None)
    const handleSortCycle = () => {
        let newOrderByItems = [];

        if (currentDirection === null || currentDirection === undefined) {
            // None -> Asc (0)
            newOrderByItems = [{ name: selectedField, operation: 0 }];
        } else if (currentDirection === 0) {
            // Asc -> Desc (1)
            newOrderByItems = [{ name: selectedField, operation: 1 }];
        } else {
            // Desc -> None (Boş liste göndererek sıralamayı kaldır)
            newOrderByItems = [];
        }

        onFilterPageSort({
            orderByItems: newOrderByItems
        });
    };

    // Dropdown değişince direkt Asc (0) ile başlat
    const handleDropdownChange = (val) => {
        onFilterPageSort({
            orderByItems: [{ name: val, operation: 0 }]
        });
    };

    // 3. İkon Belirleme
    let SortIcon = SortAscendingOutlined; // Varsayılan ikon
    let iconColor = '#bfbfbf'; // Varsayılan gri (Pasif)

    if (currentDirection === 0) {
        SortIcon = SortAscendingOutlined;
        iconColor = '#1890ff'; // Mavi (Aktif Asc)
    } else if (currentDirection === 1) {
        SortIcon = SortDescendingOutlined;
        iconColor = '#1890ff'; // Mavi (Aktif Desc)
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }} onClick={(e) => e.stopPropagation()}>
            <Select
                bordered={false}
                value={selectedField}
                size="small"
                style={{ width: 110, fontSize: 12, fontWeight: 600 }}
                dropdownMatchSelectWidth={false}
                onChange={handleDropdownChange}
                options={sortOptions}
            />

            <Tooltip title={currentDirection === null ? t('Sort Ascending') : (currentDirection === 0 ? t('Sort Descending') : t('Clear Sort'))}>
                <Button
                    type="text"
                    size="small"
                    icon={<SortIcon />}
                    style={{
                        color: iconColor,
                        backgroundColor: currentDirection !== null ? '#e6f7ff' : 'transparent' // Aktifse hafif mavi arkaplan
                    }}
                    onClick={handleSortCycle}
                />
            </Tooltip>
        </div>
    );
};